export default "__VITE_ASSET__DtbDrtze__"